(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["modal"]) return;
  try {
    
  
// Get the modal
var modal = '';
if(document.getElementById("customModal")) {
  modal = document.getElementById("customModal");
}


function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
  var popupCookie = getCookie("popupCookie1");
  if (popupCookie == "" || popupCookie == null) {
    if(modal !== ""){
      modal.style.display = "block";
    }
  }
}

checkCookie();

// Get the <span> element that closes the modal
var popupClose = document.getElementsByClassName("close")[0];


// When the user clicks on <span> (x), close the modal
popupClose.onclick = function() {
  modal.style.display = "none";
  setCookie("popupCookie1", "custompopup", 1);
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
    setCookie("popupCookie1", "custompopup", 1);
  }
}


  } catch(e) { console.error(e); }
})();
})();
